import React from 'react';
import { useLogout } from '../account/localLogout';
import useAppSelector from '../app/redux/useAppSelector';
import Avatar from '../components/Avatar';
import Menu, { MenuItem, MenuSeparator } from '../components/Menu';
import PopOver from '../components/deprecated/PopOver';
import memberIcon from '../icons/non-prefilled/16x16/member.svg';
import settingsIcon from '../icons/non-prefilled/16x16/settings.svg';
import userPath from '../utils/url/userPath';

const TopbarUserButton = () => {
  const currentUser = useAppSelector((state) => state.session.user);
  const logout = useLogout({ includeRedirectQueryString: false });

  return (
    <PopOver
      popOver={
        <Menu>
          <MenuItem icon={memberIcon} to={userPath(currentUser)}>
            Profile
          </MenuItem>
          <MenuItem icon={settingsIcon} to="/settings">
            Settings
          </MenuItem>
          <MenuSeparator />
          <MenuItem onClick={logout}>Log out</MenuItem>
        </Menu>
      }
      trigger="click"
      placement="bottom-end"
      responsivePlacement="bottom"
    >
      <Avatar user={currentUser} />
    </PopOver>
  );
};

export default TopbarUserButton;
